import React, { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import './Style.css';
import ApiSender from '../../common/ApiLogic';
import useLanguage from '../../common/useLanguage';
import Header from './components/Header';
import SiteFooter from './components/Footer';

function SuccessPage() {
  const location = useLocation();
  const apiSender = useMemo(() => new ApiSender(), []);
  const { language, selectLanguage, t } = useLanguage(location, apiSender);

  return (
    <div className="Ks-page">
      <Header language={language} onSelectLanguage={selectLanguage} />

      <div className="container standalone-page">
        <div className="form-content">
          <div className="title">
            <h4 id="headup-title">{t('Просто и безопасно', 'Жөнөкөй жана коопсуз', 'Simple and safe')}</h4>
          </div>
          <div className="form-content-middle">
            <div className="status-icon">
              <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="10" stroke="#23c11d" strokeWidth="1.8" />
                <path d="m8 12.5 2.6 2.6L16.5 9" stroke="#23c11d" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </div>
            <div className="title">
              <h3 id="title">{t('Операция выполнена успешно', 'Операция ийгиликтүү аткарылды', 'Operation completed successfully')}</h3>
            </div>
          </div>
          <div className="form-content-bottom">
            {t(
              'Проверьте SMS с ссылкой на приложение Kid Security и инструкцией по активации.',
              'Kid Security колдонмосуна шилтеме жана активдештирүү боюнча көрсөтмө камтылган SMS-ти текшериңиз.',
              'Check the SMS with the link to the Kid Security app and activation instructions.'
            )}
          </div>
        </div>
      </div>

      <SiteFooter t={t} language={language} />
    </div>
  );
}

export default SuccessPage;
